import { apolloClient } from '~/apollo-client';
import { BillingDataSource, EnrollmentDataSource } from '~/typings/context';
import {
  BillingExperienceOptionName,
  EnrollmentOptionName,
  Flex_SignUpUserMutation,
  Flex_SignUpUserMutationVariables,
} from '~/typings/graphql';
import { SIGN_UP_USER } from './sign-up-user.queries';

export interface SignUpUserParams {
  billingExperienceType: BillingDataSource;
  enrollmentDataSourceName: EnrollmentDataSource;
  planId: number;
  track: string;
  utilityAccountId: number;
  funnelVnmProjectId?: number;
  source?: string;
}

export interface SignUpUserResponse {
  plan: {
    id: number;
    planTemplateId: number;
  };
}

export const signUpUser = async (params: SignUpUserParams): Promise<SignUpUserResponse> => {
  const { data } = await apolloClient.mutate<
    Flex_SignUpUserMutation,
    Flex_SignUpUserMutationVariables
  >({
    mutation: SIGN_UP_USER,
    variables: {
      input: {
        billingExperienceType: params.billingExperienceType as BillingExperienceOptionName,
        enrollmentDataSourceName: params.enrollmentDataSourceName as EnrollmentOptionName,
        planId: params.planId,
        track: params.track,
        utilityAccountId: params.utilityAccountId,
        funnelVnmProjectId: params.funnelVnmProjectId,
        source: params.source,
      },
    },
  });

  return {
    plan: {
      id: data?.plan.id!,
      planTemplateId: data?.plan.planTemplateId!,
    },
  };
};
